import React, { useMemo } from 'react';
import classnames from 'classnames';
import { useSelector } from 'react-redux';
import Locale from '@active/react-utils/i18n/Locale';
import PaymentOptions from './components/PaymentOptions';
import PaymentMethods from './components/PaymentMethods';
import { usePaymentValidateAndSubmit } from '../../../shared/utils/customizedHooks';

const Payment = ({
  className,
  PaymentMethodNode,
  trackingCallback,
}) => {
  const {
    widgetNameSpace,
  } = useSelector(state => state.propsData);

  const paymentOptions = useSelector(state => state.paymentOptions);

  const { isRenderPaymentOptions } = paymentOptions || {};
  const isShowPaymentOptions = !!paymentOptions; // cof not show PaymentOptions section

  const {
    isRenderPaymentMethods,
  } = useSelector(state => state.paymentMethods);

  const classes = useMemo(() => classnames({
    'second-level-title': true,
    'payment-title': true,
  }, className), [ className ]);

  usePaymentValidateAndSubmit(widgetNameSpace);

  return (
    <>
      { (isRenderPaymentOptions || isRenderPaymentMethods)
        && <h2 className={classes}>
          <Locale id="checkout.lib.components.text.payment" />
        </h2>
      }
      {isShowPaymentOptions && <PaymentOptions />}
      {PaymentMethodNode ? <PaymentMethodNode /> : <PaymentMethods trackingCallback={trackingCallback}/>}
    </>
  );
};

export default Payment;
